import sample_1 from './blackline.jpg';

export const blacklineImpressions = {
    sample_1,
};
